<template>
    <div ref="reserve_vouchers" class="preview-print" hidden>
        <div
            v-for="(reserve, index) in data.reserves"
            :key="index"
            class="text-left voucher-print">
            <div class="text-center">
                <img :src="logoSRC" width="40%" alt="Não foi possível carregar o QR Code" />
                <br/>
                <br/>
                <h5>Comprovante de Reserva</h5>
            </div>
            <hr/>

            <p>
                Cliente: <span class="info">{{ control.deal.customer.name }}</span><br/>
                <span v-if="control.deal.owners">
                    <span v-if="control.deal.owners.broker">
                        Corretor(a): <span class="info">{{ control.deal.owners.broker.user.first_name }}</span><br/>
                    </span>
                    <span v-if="control.deal.owners.team">
                        Equipe: <span class="info">{{ control.deal.owners.team.name }}</span><br/>
                    </span>
                </span>
                Unidade: <span class="lastNewReserveUnityDetails">{{ unitInfos(reserve) }}</span><br/>
                <span v-if="showApprovedFolder(reserve)">
                    Etapa: <span class="info">{{ control.deal.stage ? control.deal.stage.name : '-' }}</span><br/>
                    Status: <span class="info">{{ control.deal.status ? control.deal.status.name : '-' }}</span>
                </span>
            </p>

            <div class="row">
                <div class="col-xs-5 qrcode">
                    <img :src="reserve.qr_code" width="100%" alt="Não foi possível carregar o QR Code" />
                </div>

                <div class="col-xs-7">
                    <small>
                        Código da Reserva: <span>{{ reserve.id }}</span><br/>
                        Código do Negócio: <span class="info">{{ control.deal.id }}</span><br/>
                        <br/>
                        Atendente: <span> {{ user.first_name }}</span><br/>
                        Data/Hora: <span class="lastNewReserveTime">{{ reserve.created_at | moment("DD/MM/YYYY [às] H:m") }}</span><br/>
                        <small class="showApprovedFolder"/><br/>
                    </small>
                </div>
            </div>
            <hr/>

            <small style="text-align: justify">
                Este comprovante de reserva não garante a aprovação de proposta ofertada pelo proponente,
                sua proposta está sujeita a análise e aprovação do(a) vendedor(ra)
            </small>
            <hr/>

            <p class="text-center">
                <small>Desenvolvido por <b>www.appfacilita.com </b></small>
            </p>
        </div>
    </div>
</template>

<script>
    import { currencyBRL } from '@/filters'

    import { facilita } from '@/global'

    import { mapGetters } from 'vuex'

    const defaultData = () => ({
        reserves: [],
        availability: null
    })

    export default {
        name: 'ui-reserve-voucher',

        filters: { currencyBRL },

        data() {
            return {
                data: { ...defaultData() }
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/getUser',
                definitions: 'launchDay/getDefinitions',
                control: 'launchDay/getControl'
            }),
            /**
             * Computed property que define o path para o logo da Facilita na S3
             */
            logoSRC() {
                return `${facilita.s3Host}_uploads/companies/${facilita.instance}/configurations/brandLogo.png`
            }
        },

        created() {
            this.$root.$on('print-reserve-voucher', payload => {
                this.data = { ...payload }
                this.$nextTick(() =>{
                    this.printVouchers()
                })
            })
        },

        beforeDestroy() {
            this.$root.$off('print-reserve-voucher')
        },

        methods: {
            /**
             * Computed property que retorna as informações da unidade reservada, formatadas de
             * acordo com o tipo de disponibilidade do produto
             */
            unitInfos(reserve) {
                // Constrói o label para a unidade de acordo com o tipo de disponibilidade
                let infos = ''
                const unit = { ...reserve.units }
                infos = this.data.availability && this.data.availability.type === 'vertical'
                    ? `${unit.number} - Torre ${unit.block} - Andar ${unit.floor}`
                    : `${unit.number} - Quadra ${unit.block}`
                infos += ` - ${this.$options.filters.currencyBRL(unit.cost)}`

                return infos
            },
            /**
             * Computed property que define se os dados da etapa e status do negócio vinculado à reserva
             * será mostrado, de acordo com a etapa e status definidos para o lançamento
             */
            showApprovedFolder(reserve) {
                return this.definitions &&
                    this.definitions.launchday &&
                    (reserve.stage && reserve.stage.id === this.definitions.launchday.funnel_stage_id) &&
                    (!this.definitions.launchday.funnel_stage_status_id ||
                        (reserve.status && reserve.status.id === this.definitions.launchday.funnel_stage_status_id))
            },
            /**
             * Imprime o conteúdo da div que representa o comprovante de reserva
             */
            printVouchers() {
                // Pega todas as tags style para adicionar as classes CSS no modal
                let stylesHtml = ''
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML
                }
                stylesHtml += `
                    <style type="text/css">
                        @media print {
                            @page {
                                size: portrait !important;
                                width: 80mm;
                                margin: 0px;
                            }
                        }
                    </style>
                `

                const printWindow = window.open('', 'PRINT', 'height=600,width=400')
                printWindow.document.write(`
                    <html>
                        <head>
                            ${stylesHtml}
                            <title>Imprimir Comprovante</title>
                        </head>
                        <body>
                            ${this.$refs.reserve_vouchers.innerHTML}
                        </body>
                    </html>
                `)

                printWindow.document.close() // Necessário para IE >= 10
                printWindow.focus() // Necessário para IE >= 10

                printWindow.addEventListener('load', () => {
                    printWindow.print()
                    printWindow.close()
                    this.data = { ...defaultData() }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>